import { Box, styled } from "@mui/material";

const ButtonContainer = styled(Box)(
  ({ theme }) => `
      position: absolute;
      z-index:1;
      right: 12px;
      bottom: 0px;
      color: white;
      transition: 0.8s;
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  `
);

const NavigationContainer = ({ children }) => {
  return <ButtonContainer>{children}</ButtonContainer>;
};

export default NavigationContainer;
